import { render, staticRenderFns } from "./savedialog.vue?vue&type=template&id=44c688a8&"
import script from "./savedialog.vue?vue&type=script&lang=js&"
export * from "./savedialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/willy/code/fake-the-wheel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44c688a8')) {
      api.createRecord('44c688a8', component.options)
    } else {
      api.reload('44c688a8', component.options)
    }
    module.hot.accept("./savedialog.vue?vue&type=template&id=44c688a8&", function () {
      api.rerender('44c688a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "static/savedialog.vue"
export default component.exports